import React from 'react';
import {
    Show,
    TextField,
    SelectField,
    CardActions,
    EditButton,
    DateField,
    FunctionField
} from 'react-admin';
import {
    Card,
    CardContent
} from '@material-ui/core';

import "../division/styles/main.css"

const LicenseShowTitle = ({ record }) => {
    return <span>Ліцензії: {record ? `"${record.licenseId}"` : ''}</span>;
};

const Label = (prop) => {
    return (
        <span style={labelStyle}>{prop.caption}: </span>
    );
}

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 300,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const LicenseActions = ({ data }) => {
    return data && data.isPrimary ? null : <CardActions>
        <EditButton record={data} label={"Редагувати"} />
    </CardActions>
};

const LicenseShow = (props) => {
    return (
        <Show className="show-styles" {...props} title={<LicenseShowTitle/>} actions={<LicenseActions />}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <CardContent style={rowStyle}>
                            <Label caption={"Тип ліцензії"}/>
                            <SelectField formClassName="tab-content-item" label="Тип ліцензії" source="type" choices={[
                                { id: 'MSP', name: 'ліцензія на провадження господарської діяльності з медичної практики' },
                                { id: 'PHARMACY', name: 'ліцензія на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами' },
                                { id: 'PHARMACY_DRUGS', name: 'ліцензія на право провадження господарської діяльності з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
                            ]} />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Ким видана"}/>
                            <TextField formClassName="tab-content-item" label="Ким видана" source="issuedBy" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Номер наказу"}/>
                            <TextField formClassName="tab-content-item" label="Номер наказу" source="orderNo" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Серія та номер ліцензії"}/>
                            <TextField formClassName="tab-content-item" label="Серія та номер ліцензії" source="licenseNumber" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Дата видачі ліцензії"}/>
                            <DateField sortable={false} label="Дата видачі ліцензії" source="issuedDate" locales="ru-RU" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Дата початку дії ліцензії"}/>
                            <DateField sortable={false} label="Дата початку дії ліцензії" source="activeFromDate" locales="ru-RU" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Дата завершення дії ліцензії"}/>
                            <DateField sortable={false} label="Дата завершення дії ліцензії" source="expiryDate" locales="ru-RU" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Номер наказу"}/>
                            <TextField formClassName="tab-content-item" label="Номер наказу" source="orderNo" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Вид діяльності, що ліцензовано"}/>
                            <TextField formClassName="tab-content-item" label="Вид діяльності, що ліцензовано" source="whatLicensed" />
                        </CardContent>

                        <CardContent style={rowStyle}>
                            <Label caption={"Основна ліцензія"}/>
                            <FunctionField render={record => record.isPrimary ? 'так' : 'ні'} />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </Show>
    );
};

export default LicenseShow;
